import React from 'react';
import { Flex, Text } from '@chakra-ui/react';
import ReactPaginate from 'react-paginate';

/** Pie de tabla con el mismo look que la paginación de Clases grabadas. */
export default function AiPagination({ pagination, noun, onPageChange, extra }) {
  if (!pagination || pagination.total === 0) return null;
  const { page, pageSize, total, pageCount } = pagination;
  const from = (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, total);
  return (
    <Flex px={5} py={4} borderTopWidth="1px" borderColor="gray.100" align="center" justify="space-between" gap={4} wrap="wrap">
      <Text fontSize="13px" color="gray.600">
        Mostrando {from}-{to} de {total} {noun}
        {extra ? <Text as="span" color="gray.400"> · {extra}</Text> : null}
      </Text>
      {pageCount > 1 && (
        <ReactPaginate
          breakLabel="..."
          nextLabel=">"
          previousLabel="<"
          onPageChange={({ selected }) => onPageChange(selected + 1)}
          pageRangeDisplayed={3}
          marginPagesDisplayed={1}
          pageCount={pageCount}
          forcePage={page - 1}
          renderOnZeroPageCount={null}
          containerClassName="aiPagination"
          pageClassName="aiPaginationItem"
          breakClassName="aiPaginationBreak"
          activeClassName="aiPaginationActive"
          previousClassName="aiPaginationItem"
          nextClassName="aiPaginationItem"
          disabledClassName="aiPaginationDisabled"
        />
      )}
      <style>{`
        .aiPagination { display: flex; align-items: center; list-style: none; gap: 4px; margin: 0; padding: 0; }
        .aiPaginationItem {
          display: flex; align-items: center; justify-content: center;
          min-width: 36px; height: 36px;
          border: 1px solid #e2e8f0; border-radius: 6px;
          cursor: pointer; font-size: 14px; color: #4a5568; transition: all 0.2s;
        }
        .aiPaginationItem:hover { background-color: #f7fafc; border-color: #cbd5e0; }
        .aiPaginationItem a { display: flex; align-items: center; justify-content: center; width: 100%; height: 100%; padding: 0 12px; }
        .aiPaginationBreak { padding: 0 4px; color: #a0aec0; }
        .aiPaginationActive { background-color: #574feb !important; border-color: #574feb !important; color: white !important; }
        .aiPaginationActive a { color: white !important; }
        .aiPaginationDisabled { opacity: 0.5; cursor: not-allowed; }
      `}</style>
    </Flex>
  );
}
